import Tags from "../utils/Tags";
import LikeBtn from "./LikeBtn";
import SaveBtn from "./SaveBtn";

export default function DetailedBlog({ blog }) {
  const { id, title, description, image, tags, isSaved, likes } = blog;

  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1
          className="mt-6 text-2xl post-title"
          id="lws-singleTitle"
        >
          {title}
        </h1>

        <Tags
          className="lws-tags"
          tags={tags}
        />

        <div className="btn-group">
          <LikeBtn
            id={id}
            likes={likes}
          />
          <SaveBtn
            id={id}
            saved={isSaved}
          />
        </div>

        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
}
